import { Controller, ControllerProps, FieldError, FieldValues, Path } from 'react-hook-form';
import { FormattedMessage } from 'react-intl';

import { FormErrorHelperText } from '../FormErrorHelperText';
import { DateNumberFormat, DateNumberFormatProps } from './DateNumberFormat';

export const MonthInput = <
  TFieldValues extends FieldValues = FieldValues,
  TName extends Path<TFieldValues> = Path<TFieldValues>
>({
  controllerProps,
  error,
  setValue,
  ...dateNumberFormatProps
}: {
  controllerProps: Omit<ControllerProps<TFieldValues, TName>, 'render'>;
  error?: FieldError;
  // TODO: Really want to use UseFormSetValue but we need to guarantee that the TName (schema path to the property we're
  //  modifying with this input) maps to a string value.
  setValue: (key: TName, value: string) => void;
} & DateNumberFormatProps) => {
  return (
    <Controller
      {...controllerProps}
      render={({ field: { onBlur, ref, value, ...rest } }) => {
        const handleOnBlur = () => {
          onBlur();
          setValue(controllerProps.name, `${parseInt(value)}`.padStart(2, '0'));
        };

        return (
          <DateNumberFormat
            error={Boolean(error)}
            helperText={<FormErrorHelperText error={error} fieldName="Month" />}
            format="##"
            inputRef={ref}
            label={<FormattedMessage id="month" defaultMessage="Month" />}
            mask="M"
            onBlur={handleOnBlur}
            value={value}
            {...dateNumberFormatProps}
            {...rest}
          />
        );
      }}
    />
  );
};
